<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_acc_location.edit_title') + (location ? (` : ${location.name}`) : '')"
           fixed-tabs>
    <template #content>
      <v-container class="edit-location-content pa-0" fluid v-if="location">
        <v-tabs fixed-tabs
                v-model="tabIndex">
          <v-tab>{{ $t('register.basic_info') }}</v-tab>
          <v-tab-item>
            <v-container class="overflow-y-scroll" fluid>
              <v-form ref="locationForm">
                <v-text-field outlined
                              :label="$t('admin_acc_location.name_en')"
                              v-model="location.name_en"
                              :rules="requiredRules"></v-text-field>
                <v-text-field outlined
                              :label="$t('admin_acc_location.name_zh')"
                              v-model="location.name_zh"
                              :rules="requiredRules"></v-text-field>
                <v-text-field outlined
                              :label="$t('admin_acc_location.address_en')"
                              v-model="location.address_en"
                              :rules="requiredRules"></v-text-field>
                <v-text-field outlined
                              :label="$t('admin_acc_location.address_zh')"
                              v-model="location.address_zh"
                              :rules="requiredRules"></v-text-field>
              </v-form>
            </v-container>
          </v-tab-item>

          <v-tab>{{ $t('admin_acc_region.title') }}</v-tab>
          <v-tab-item>
            <RegionList full-height
                        :location-id="locationId"
                        @edit="onRegionEdit"
                        :refresh-trigger.sync="regionRefreshTrigger"
                        v-if="tabIndex === 1"></RegionList>

            <EditRegionModal :region-id="editingRegionId"
                             :shown="editRegionModalShown"
                             @cancel="onEditRegionModalFinish"></EditRegionModal>
          </v-tab-item>

          <v-tab>{{ $t('admin_acc_item.title') }}</v-tab>
          <v-tab-item>
            <ItemList full-height
                      :location-id="locationId"
                      :refresh-trigger.sync="itemRefreshTrigger"
                      @edit="onItemEdit"
                      v-if="tabIndex === 2"></ItemList>

            <EditItemModal :item-id="editingItemId"
                           :shown="editItemModalShown"
                           @cancel="onEditItemModalFinish"></EditItemModal>
          </v-tab-item>

        </v-tabs>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               depressed
               large
               @click="$refs.locationForm.validate() && saveLocation()"
               v-if="tabIndex === 0">
          {{ $t('save') }}
          <v-icon right>fas fa-check</v-icon>
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import BGModal from "@/components/BGModal";
import {ref, watch} from "@vue/composition-api";
import RegionList from "@/components/acc_booking/region/RegionList";
import ItemList from "@/components/acc_booking/item/ItemList";
import EditRegionModal from "@/components/acc_booking/region/EditRegionModal";
import EditItemModal from "@/components/acc_booking/item/EditItemModal";

export default {
  name: 'EditLocationModal',
  components: {EditItemModal, EditRegionModal, ItemList, RegionList, BGModal},
  props: {
    locationId: String,
    shown: Boolean,
  },
  setup(props, {root, emit}) {
    const dialogShown = ref(props.shown);
    const cancel = function () {
      emit('cancel');
    };

    const tabIndex = ref(0);

    // Init
    watch(() => props.shown, async (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          getLocation()
        }
      }

      tabIndex.value = 0;
    });

    //
    const location = ref(null);
    const getLocation = function () {
      root.$callAPI('aafb/admin/location/', {location_id: props.locationId}, function (response) {
        location.value = response.body.location;
      });
    }

    //
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);
    const saveLocation = function () {
      root.$callAPI('aafb/admin/location/set/', {
        ...location.value,
        location_id: props.locationId,
      }, () => {
        root.$showAlertMessage('Info Saved');
        getLocation()
      })
    }

    //
    const regionRefreshTrigger = ref(false);
    const editingRegionId = ref(null);
    const editRegionModalShown = ref(false);
    const onRegionEdit = function (item) {
      editingRegionId.value = item.id;
      editRegionModalShown.value = true;
    };
    const onEditRegionModalFinish = function () {
      regionRefreshTrigger.value = true;
      editingRegionId.value = null;
      editRegionModalShown.value = false;
    }

    //
    const itemRefreshTrigger = ref(false);
    const editingItemId = ref(null);
    const editItemModalShown = ref(false);
    const onItemEdit = function (item) {
      editingItemId.value = item.id;
      editItemModalShown.value = true;
    };
    const onEditItemModalFinish = function () {
      itemRefreshTrigger.value = true;
      editingItemId.value = null;
      editItemModalShown.value = false;
    }

    return {
      dialogShown,
      cancel,

      tabIndex,

      location,
      requiredRules,
      saveLocation,

      regionRefreshTrigger,
      editingRegionId,
      editRegionModalShown,
      onRegionEdit,
      onEditRegionModalFinish,

      itemRefreshTrigger,
      editingItemId,
      editItemModalShown,
      onItemEdit,
      onEditItemModalFinish,
    }
  }
}
</script>

<style lang="less">
.edit-location-content {
  display: flex;
  height: 100%;
}
</style>
